import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Typo, HR, Form } from 'tmt-ui-kit';
import Router from 'next/router';
import PropTypes from 'prop-types';

import withTrip from './withTrip';

const TripGroupLabel = styled(Typo.Medium)`
  margin: 0 0 16px !important;
  font-size: 16px !important;
`;

const onChangeTripGroup = (slug) => {
  if (!slug) return;
  Router.push(
    {
      pathname: '/trip-detail',
      query: {
        slug
      },
    },
    `/trip/${slug}`
  );
};

const GroupedTripSelector = (props) => {
  const { trip, hideHR = false } = props;
  const groupedTrips = trip.grouped_trips && trip.grouped_trips.trip_ids.map(tripInGroup => ({
    value: tripInGroup.trip.slug,
    label: tripInGroup.label,
    active: tripInGroup.trip._id === trip._id
  }));
  return (
    <Fragment>
      {trip.grouped_trips && trip.grouped_trips.trip_ids.length > 0 && (
        <div>
          <TripGroupLabel>{trip.grouped_trips.label}</TripGroupLabel>
          <Form.RadioButton
            onChange={value => onChangeTripGroup(value)}
            values={groupedTrips}
          />
          {!hideHR && <HR />}
        </div>
      )}
    </Fragment>
  );
};

GroupedTripSelector.propTypes = {
  trip: PropTypes.object,
};

export default withTrip(GroupedTripSelector);
